export default function CentralTabContent({ children, className }: { children?: any, className?: string }): JSX.Element {
    return <>
        <div className={"grid col-span-4 text-center text-lg md:text-xl font-roboto " +
            " font-light tracking-wider w-full " + className}>
            {children}
        </div>
    </>
}